import { createContext, useContext, useState } from 'react';

const PromptContext = createContext();

export const usePrompts = () => {
  const context = useContext(PromptContext);
  if (!context) {
    throw new Error('usePrompts must be used within a PromptProvider');
  }
  return context;
};

export const PromptProvider = ({ children }) => {
  const [prompts, setPrompts] = useState([]);

  const addPrompt = prompt => {
    const newPrompt = {
      id: Date.now().toString(),
      title: prompt.title,
      prompt: prompt.prompt,
      type: '사용자 추가',
      category: '내 프롬프트',
      createdAt: new Date().toISOString(),
    };
    setPrompts(prev => [...prev, newPrompt]);
    return newPrompt;
  };

  const updatePrompt = (id, updatedPrompt) => {
    setPrompts(prev =>
      prev.map(p =>
        p.id === id
          ? { ...p, ...updatedPrompt, updatedAt: new Date().toISOString() }
          : p
      )
    );
  };

  const deletePrompt = id => {
    setPrompts(prev => prev.filter(p => p.id !== id));
  };

  const getPrompt = id => {
    return prompts.find(p => p.id === id);
  };

  const value = {
    prompts,
    addPrompt,
    updatePrompt,
    deletePrompt,
    getPrompt,
  };

  return (
    <PromptContext.Provider value={value}>{children}</PromptContext.Provider>
  );
};
